import React from 'react';
import {  Grid, Typography, Button  } from '@mui/material';
import AccessDeniedImg from '../assets/access_denied.png'
import { useNavigate } from "react-router-dom";

const AccessDenied = () => {
    const navigate = useNavigate();
    return (
      <Grid
        container
        spacing={0}
        direction="column"
        alignItems="center"
        justifyContent="center"
        sx={{ minHeight: '80vh' }}
      >
        <img style={{maxWidth:'100%'}} alt="access_denied" src={AccessDeniedImg}  />
        <Typography sx={{paddingBottom:'10px'}} variant="h6">Access Denied</Typography>
        <Typography sx={{paddingBottom:'20px'}} variant="span">You do not have permission to view this page. </Typography>
        <Button onClick={(e)=>{navigate('/web/dashboard')}}  variant="contained">Dashboard</Button>
      </Grid>
  )
}

export default AccessDenied